import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { AddressProducts, IPopupModelV2, ModalChild, Sparte } from '@mwe/models';
import { ClickableProductsCardComponent } from '../cards/clickable-products-card/clickable-products-card.component';
import { ModalComponent } from '../modal/modal.component';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { getCompanyCorrelationFromCategory } from '@mwe/utils';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmobCancellationStore, MoveOutLogic } from '@mwe/services';

@Component({
  selector: 'mwe-cancellation-modal',
  imports: [ModalComponent, TranslatePipe, ClickableProductsCardComponent, TranslateDirective],
  templateUrl: './cancellation-modal.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CancellationModalComponent implements ModalChild {
  private readonly activeModal = inject(NgbActiveModal);
  private readonly emobilityCancelationStore = inject(EmobCancellationStore);
  private readonly moveOutLogic = inject(MoveOutLogic);

  loadedData: AddressProducts;

  readonly popupModel = signal<IPopupModelV2>(null);

  protected readonly Sparte = Sparte;
  readonly stromCompany = computed(() => getCompanyCorrelationFromCategory(Sparte.Strom));
  readonly waermeCompany = computed(() => getCompanyCorrelationFromCategory(Sparte.Fernwaerme));
  readonly emobilityCompany = computed(() => getCompanyCorrelationFromCategory(Sparte.Emobility));

  startEmobCancellation() {
    this.closePopup();
    this.emobilityCancelationStore.initEmobCancellationProcess(this.loadedData);
  }

  startDefaultCancellation() {
    this.closePopup();
    if (!this.loadedData) {
      this.moveOutLogic.startProcessWithAddressSelection();
      return;
    }
    this.moveOutLogic.startProcessWithoutAddressSelection(this.loadedData.products, this.loadedData.address);
  }

  private closePopup() {
    this.activeModal.close();
  }
}
